import { AppComponent } from '../components/app.component'
import { Injectable, EventEmitter } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { LoginService } from './login.service';
import { Exam } from 'app/lib/Exam';
import { Task, TaskType, MultipleChoiceOption } from 'app/lib/Task';
import { EditorContentService } from './editorcontent.service';


// #########################################################################
//
// This service is used to manage the login-state
//
// #########################################################################

declare var swal: any;

@Injectable()
export class ExamService {
    private examModeOn_: boolean = false;
    

    public examModeIsOn(): boolean {
        //TODO: implement
        return this.examModeOn_;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/exam.service.ts